const syncAddToCartPrice = () => {
    const priceEl = document.querySelector('[data-product-price]');
    const addToCartPriceEl = document.querySelector('[data-add-to-cart-price]');

    if (!priceEl || !addToCartPriceEl) return;

    const updateAddToCartPrice = () => {
        addToCartPriceEl.textContent = priceEl.textContent;
    };

    // Initial sync
    updateAddToCartPrice();

    // Watch for text/content changes
    const observer = new MutationObserver(() => updateAddToCartPrice());

    observer.observe(priceEl, {
        childList: true,
        characterData: true,
        subtree: true
    });
};

// On a bundle with 3+ variant options (e.g. Size / Lighting / Stand), a
// later option's available values depend on an earlier one (a bigger Cinco
// stand only exists for bigger trees). Shopify's own variant-availability
// check ("SelloutVariants" in theme.js) treats every option as equal
// priority - so switching to a smaller tree size while a bigger stand is
// still selected marks the SIZE and LIGHTING buttons "unavailable" too,
// since the exact combination no longer exists, instead of just clearing
// the now-invalid stand choice. This makes an earlier option (lower
// position number) take priority: after any option changes, any LATER
// option whose current value no longer forms a real combination gets reset
// to the first value that does, cascading left-to-right.
const initOptionPriority = () => {
    const productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    let product;
    try {
        product = JSON.parse(productJsonEl.textContent);
    } catch (e) {
        return;
    }
    if (!product.variants || !product.variants[0] || !product.variants[0].options) return;

    const wrappers = Array.from(document.querySelectorAll('.selector-wrapper[data-option-position]'))
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
    if (wrappers.length < 2) return; // nothing to prioritise with only one option

    const radios = (wrapper) => Array.from(wrapper.querySelectorAll('input[type="radio"]'));
    const checkedValue = (wrapper) => radios(wrapper).find((input) => input.checked)?.value;

    // Does any variant match these option values, position by position?
    // Positions past the end of `values` are wildcards (not yet decided).
    const variantExists = (values) => product.variants.some((variant) =>
        variant.options.every((optionValue, index) => values[index] === undefined || values[index] === optionValue)
    );

    const enforcePriority = () => {
        const selections = wrappers.map(checkedValue);

        for (let position = 1; position < wrappers.length; position += 1) {
            if (variantExists(selections.slice(0, position + 1))) continue;

            const earlier = selections.slice(0, position);
            const fallback = radios(wrappers[position]).find((input) =>
                variantExists([...earlier, input.value])
            );
            if (!fallback || fallback.checked) continue;

            fallback.checked = true;
            fallback.dispatchEvent(new Event('change', {bubbles: true}));
            selections[position] = fallback.value;
        }
    };

    // Only the options that have something after them can invalidate a
    // later choice - the last option never needs to trigger this.
    wrappers.slice(0, -1).forEach((wrapper) => {
        wrapper.addEventListener('change', () => setTimeout(enforcePriority, 0));
    });
};

// Initialise
document.addEventListener('DOMContentLoaded', () => {
    syncAddToCartPrice();
    initOptionPriority();
});
